<template>

    <!-- search-top -- >
    <div class="search-top">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <div class="search-box">
            <div class="todayselect">
              <select class="form-control" aria-label="agents">
                <option>Select agents</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-8">
          <div class="export-right">
            <div class="export">
              <a href="#"> My Reports</a>
            </div>
            <div class="todayselect">
              <div class="reportrange">
                This Month <i class="fa fa-angle-down" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <! -- search-top -->

    <!-- all-task -->
    <div class="all-task">
      <div class="row">
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Appointments.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ todayAppointments }}</h5>
                <p>Today’s Appointments </p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Tasks.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ newMessages }}</h5>
                <p>New Messages</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Alarts.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ unreadMessages }}</h5>
                <p>Unread Messages</p>
              </div>
            </a>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
          <div class="tasks">
            <a href="#" class="media">
              <img src="@/assets/img/Untouched.svg" class="mr-3 img-fluid" alt="image title">
              <div class="media-body">
                <h5 class="mt-0">{{ pendingFollowUp }}</h5>
                <p>Pending Follow Up</p>
              </div>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- all-task -->


    <!-- activity-area -->
    <div class="activity-area">
      <div class="row">

        <!-- left-side -->
        <div class="col-md-7 col-lg-8">
          <div class="row">
            <div class="col-12">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="activetab">
                  <ul>
                    <li>
                      <a class="active" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11.3339 4.80612C12.8272 4.6869 14.2448 4.09954 15.3848 3.1277C16.6724 2.03102 18.3085 1.42871 19.9999 1.42871C21.6913 1.42871 23.3273 2.03102 24.615 3.1277C25.755 4.09954 27.1726 4.6869 28.6659 4.80612C30.3523 4.9409 31.9356 5.67195 33.1318 6.8682C34.3281 8.06446 35.0591 9.64771 35.1939 11.3341C35.3123 12.8268 35.8996 14.2452 36.8723 15.3851C37.969 16.6727 38.5713 18.3088 38.5713 20.0001C38.5713 21.6915 37.969 23.3276 36.8723 24.6152C35.9005 25.7553 35.3131 27.1729 35.1939 28.6662C35.0591 30.3526 34.3281 31.9358 33.1318 33.1321C31.9356 34.3283 30.3523 35.0594 28.6659 35.1942C27.1726 35.3134 25.755 35.9007 24.615 36.8726C23.3273 37.9693 21.6913 38.5716 19.9999 38.5716C18.3085 38.5716 16.6724 37.9693 15.3848 36.8726C14.2448 35.9007 12.8272 35.3134 11.3339 35.1942C9.64746 35.0594 8.06422 34.3283 6.86796 33.1321C5.6717 31.9358 4.94065 30.3526 4.80588 28.6662C4.68665 27.1729 4.0993 25.7553 3.12746 24.6152C2.03077 23.3276 1.42847 21.6915 1.42847 20.0001C1.42847 18.3088 2.03077 16.6727 3.12746 15.3851C4.0993 14.245 4.68665 12.8274 4.80588 11.3341C4.94065 9.64771 5.6717 8.06446 6.86796 6.8682C8.06422 5.67195 9.64746 4.9409 11.3339 4.80612V4.80612ZM28.6056 16.9985C29.0285 16.5606 29.2624 15.9742 29.2572 15.3656C29.2519 14.7569 29.0077 14.1746 28.5773 13.7442C28.1469 13.3138 27.5646 13.0696 26.9559 13.0643C26.3473 13.0591 25.7609 13.293 25.323 13.7159L17.6784 21.3605L14.6768 18.3589C14.2389 17.936 13.6525 17.702 13.0438 17.7073C12.4352 17.7126 11.8529 17.9567 11.4225 18.3871C10.9921 18.8176 10.7479 19.3998 10.7426 20.0085C10.7373 20.6172 10.9713 21.2036 11.3942 21.6414L16.0371 26.2844C16.4725 26.7196 17.0629 26.9641 17.6784 26.9641C18.294 26.9641 18.8844 26.7196 19.3197 26.2844L28.6056 16.9985V16.9985Z"
                            fill="#605BFF" />
                        </svg>
                        <h3>{{ newContacts }}</h3>
                        <p>New Contacts</p>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path
                            d="M17.5401 34.7423C18.6209 33.0858 17.6106 31.0063 15.6956 30.4894C15.9188 29.4673 15.7191 28.5157 15.0259 27.705C14.3445 26.9062 13.4634 26.5302 12.3708 26.5889C12.3708 25.6491 12.0771 24.8267 11.4075 24.1688C10.7378 23.4991 9.91541 23.2054 8.92855 23.2877C8.9403 21.9836 8.41162 20.9732 7.30728 20.3388C6.19119 19.7044 5.08684 19.7984 4.07648 20.6443C3.84152 20.3741 3.6183 20.1039 3.37158 19.8101C3.44207 19.7162 3.50081 19.5987 3.58305 19.5047C6.05021 16.2856 8.51736 13.0783 10.9845 9.8593C11.1607 9.63608 11.3252 9.60083 11.6072 9.58909C12.829 9.56559 14.0391 9.4951 15.2492 9.41286C16.5062 9.31887 17.7633 9.17789 19.0204 9.08391C19.8898 9.02516 20.7474 9.1544 21.6403 9.5186C21.1938 9.67132 20.8061 9.77706 20.4302 9.91804C19.0204 10.435 17.6341 10.9754 16.2125 11.4571C15.6604 11.645 15.0729 11.7508 14.4973 11.8213C12.3826 12.0797 12.2651 13.9477 13.064 15.1108C13.7924 16.1564 14.838 16.7321 16.0833 16.7438C17.1172 16.7556 18.151 16.5794 19.1849 16.4619C19.7135 16.4031 20.2305 16.3209 20.7591 16.2504C21.4405 16.1564 22.0632 16.3561 22.5919 16.7438C23.6962 17.5662 24.7888 18.4238 25.8697 19.2815C27.9256 20.9145 29.9698 22.571 32.0258 24.204C32.719 24.768 32.9187 25.4259 32.6132 26.2247C32.296 27.0471 31.4736 27.6463 30.6865 27.5641C30.4515 27.5406 30.2048 27.4231 30.0168 27.2821C28.7128 26.26 27.4205 25.2144 26.1164 24.1805C25.9637 24.0631 25.7522 23.9103 25.576 23.9338C25.3997 23.9573 25.1413 24.1453 25.106 24.298C25.0708 24.4977 25.1648 24.8032 25.3058 24.9442C25.7992 25.4024 26.3514 25.8018 26.88 26.2247C27.256 26.5302 27.6437 26.8239 28.0079 27.1411C28.7363 27.7638 28.7598 28.8564 28.0784 29.667C27.4322 30.4542 26.4571 30.5834 25.7052 29.9842C24.8358 29.3028 23.9782 28.6097 23.1206 27.9165C22.8856 27.7285 22.6389 27.6228 22.3569 27.8225C22.028 28.0575 22.0397 28.4569 22.3922 28.7506C22.9561 29.2206 23.5318 29.667 24.1074 30.1369C24.7888 30.6891 24.9651 31.4528 24.5891 32.2634C24.2132 33.0858 23.3555 33.591 22.5684 33.4382C22.3922 33.403 22.2159 33.309 22.0632 33.1915C21.4405 32.7098 20.8296 32.2047 20.1952 31.7112C19.8428 31.4293 19.5138 31.441 19.3141 31.7347C19.0909 32.0637 19.1966 32.3456 19.4903 32.5689C19.9368 32.9213 20.3597 33.3207 20.8414 33.638C21.2173 33.8847 21.2643 34.2019 21.2056 34.5896C21.0881 35.2592 20.5242 35.8936 19.8545 35.9876C19.5726 36.0346 19.2554 35.9406 18.9734 35.8349C18.7737 35.7644 18.6209 35.5764 18.4447 35.4355C18.151 35.2357 17.8456 34.989 17.5401 34.7423Z"
                            fill="#A5A5A5" />
                          <path
                            d="M36.7248 19.9043C35.5617 21.3376 34.0814 22.2422 32.4484 22.9119C32.3309 22.9589 32.096 22.8531 31.9667 22.7474C29.4408 20.7384 26.9149 18.7177 24.4008 16.697C23.4844 15.9569 22.5446 15.1932 21.2992 15.158C20.4299 15.1345 19.5487 15.3342 18.6793 15.4164C17.7865 15.4987 16.9053 15.6279 16.0125 15.6279C15.3193 15.6279 14.6849 15.3225 14.2267 14.782C13.98 14.5001 13.8273 14.1124 13.7333 13.7364C13.6511 13.4075 13.8625 13.149 14.215 13.0668C14.3677 13.0315 14.5322 12.9845 14.6849 12.9728C16.4237 12.8083 17.9862 12.0564 19.5722 11.422C21.264 10.7406 23.0027 10.4586 24.8002 10.3529C26.1278 10.2707 27.4671 10.1649 28.7124 9.60101C28.8064 9.55401 29.0414 9.70674 29.1354 9.82423C30.8271 12.0564 32.5072 14.3003 34.1989 16.5443C35.0448 17.6604 35.8789 18.7765 36.7248 19.9043Z"
                            fill="#A5A5A5" />
                          <path
                            d="M2.49049 19.1052C1.93832 18.6587 1.40965 18.271 0.916215 17.8246C0.070334 17.0727 -0.129388 16.1211 0.387539 15.1225C0.692997 14.5115 1.08069 13.9359 1.50363 13.3837C2.72546 11.7742 3.97079 10.1764 5.21611 8.57863C5.46283 8.26143 5.78003 7.97947 6.08549 7.70925C6.87263 7.05135 7.60103 6.96911 8.4704 7.50953C9.11656 7.90898 9.70398 8.39066 10.3501 8.86059C7.71851 12.3029 5.12212 15.6864 2.49049 19.1052Z"
                            fill="#A5A5A5" />
                          <path
                            d="M29.7932 8.82531C30.4629 8.35537 31.062 7.87369 31.7082 7.486C32.5658 6.96907 33.2942 7.06305 34.0579 7.72096C34.4573 8.06166 34.8333 8.44936 35.1505 8.86055C36.4193 10.5171 37.6646 12.1853 38.8864 13.8653C39.2271 14.3353 39.5091 14.864 39.7558 15.3926C40.12 16.1915 40.0025 16.9669 39.3799 17.5896C38.8277 18.1417 38.205 18.6352 37.5824 19.1874C34.9625 15.7098 32.4013 12.3028 29.7932 8.82531Z"
                            fill="#A5A5A5" />
                          <path
                            d="M2.70166 24.2042C2.86614 23.8753 2.98362 23.4993 3.21859 23.2291C3.75901 22.5947 4.33468 21.9838 4.9221 21.3964C5.09832 21.2201 5.35679 21.0792 5.59175 21.0439C6.34365 20.9264 7.23652 21.4669 7.60072 22.207C7.97667 22.9471 7.87093 23.5816 7.24827 24.2512C6.76659 24.7681 6.27316 25.2616 5.81497 25.802C5.49777 26.1779 5.09832 26.2837 4.64014 26.2484C3.64153 26.1662 2.79565 25.2616 2.70166 24.2042Z"
                            fill="#A5A5A5" />
                          <path
                            d="M8.30558 29.6786C7.15425 29.5728 6.19088 28.6447 6.24962 27.5639C6.27312 27.2232 6.42585 26.8472 6.63732 26.577C7.04851 26.0483 7.55369 25.5901 8.00013 25.085C8.44656 24.568 8.96349 24.2743 9.65664 24.4388C10.4203 24.6268 10.9137 25.1085 11.1604 25.8369C11.3602 26.4478 11.2427 26.9882 10.7962 27.4581C10.2676 28.0221 9.76238 28.6212 9.19846 29.1499C8.96349 29.3849 8.61104 29.5141 8.30558 29.6786Z"
                            fill="#A5A5A5" />
                          <path
                            d="M9.57471 30.8887C9.73918 30.5597 9.83317 30.172 10.0681 29.9018C10.5968 29.2557 11.1725 28.6448 11.7834 28.0691C11.9949 27.8694 12.3356 27.7166 12.6293 27.7049C13.8864 27.6579 14.9437 28.915 14.6265 30.0663C14.556 30.3248 14.3915 30.5715 14.2153 30.783C13.7806 31.2881 13.3224 31.7581 12.876 32.2398C12.2533 32.9094 11.6894 33.0621 10.961 32.7684C10.1856 32.463 9.66869 31.7228 9.57471 30.8887Z"
                            fill="#A5A5A5" />
                          <path
                            d="M14.9436 35.4589C14.133 35.3767 13.3341 34.7423 13.2283 33.9786C13.1931 33.7554 13.2871 33.4617 13.4398 33.2855C13.8745 32.7568 14.3797 32.2751 14.8379 31.7582C15.0141 31.5585 15.1786 31.535 15.4135 31.6055C16.001 31.7817 16.4474 32.1341 16.7411 32.6746C16.9996 33.1562 16.9526 33.6967 16.6001 34.1079C16.2947 34.4603 15.9892 34.8245 15.6368 35.13C15.4488 35.2827 15.1786 35.3532 14.9436 35.4589Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ activeContacts }}</h3>
                        <p>Active Contacts</p>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path
                            d="M30.0001 8.5715H28.5715V7.14293C28.5715 6.28578 28.0001 5.71436 27.1429 5.71436C26.2858 5.71436 25.7144 6.28578 25.7144 7.14293V8.5715H14.2858V7.14293C14.2858 6.28578 13.7144 5.71436 12.8572 5.71436C12.0001 5.71436 11.4286 6.28578 11.4286 7.14293V8.5715H10.0001C7.5715 8.5715 5.71436 10.4286 5.71436 12.8572V14.2858H34.2858V12.8572C34.2858 10.4286 32.4286 8.5715 30.0001 8.5715ZM5.71436 30.0001C5.71436 32.4286 7.5715 34.2858 10.0001 34.2858H30.0001C32.4286 34.2858 34.2858 32.4286 34.2858 30.0001V17.1429H5.71436V30.0001ZM27.1429 20.0001C28.0001 20.0001 28.5715 20.5715 28.5715 21.4286C28.5715 22.2858 28.0001 22.8572 27.1429 22.8572C26.2858 22.8572 25.7144 22.2858 25.7144 21.4286C25.7144 20.5715 26.2858 20.0001 27.1429 20.0001ZM27.1429 25.7144C28.0001 25.7144 28.5715 26.2858 28.5715 27.1429C28.5715 28.0001 28.0001 28.5715 27.1429 28.5715C26.2858 28.5715 25.7144 28.0001 25.7144 27.1429C25.7144 26.2858 26.2858 25.7144 27.1429 25.7144ZM20.0001 20.0001C20.8572 20.0001 21.4286 20.5715 21.4286 21.4286C21.4286 22.2858 20.8572 22.8572 20.0001 22.8572C19.1429 22.8572 18.5715 22.2858 18.5715 21.4286C18.5715 20.5715 19.1429 20.0001 20.0001 20.0001ZM20.0001 25.7144C20.8572 25.7144 21.4286 26.2858 21.4286 27.1429C21.4286 28.0001 20.8572 28.5715 20.0001 28.5715C19.1429 28.5715 18.5715 28.0001 18.5715 27.1429C18.5715 26.2858 19.1429 25.7144 20.0001 25.7144ZM12.8572 20.0001C13.7144 20.0001 14.2858 20.5715 14.2858 21.4286C14.2858 22.2858 13.7144 22.8572 12.8572 22.8572C12.0001 22.8572 11.4286 22.2858 11.4286 21.4286C11.4286 20.5715 12.0001 20.0001 12.8572 20.0001ZM12.8572 25.7144C13.7144 25.7144 14.2858 26.2858 14.2858 27.1429C14.2858 28.0001 13.7144 28.5715 12.8572 28.5715C12.0001 28.5715 11.4286 28.0001 11.4286 27.1429C11.4286 26.2858 12.0001 25.7144 12.8572 25.7144Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ appointmentScheduled }}</h3>
                        <p>Appointment Scheduled</p>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path
                            d="M18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12ZM34 12C34 12.7879 33.8448 13.5681 33.5433 14.2961C33.2418 15.0241 32.7998 15.6855 32.2426 16.2426C31.6855 16.7998 31.0241 17.2418 30.2961 17.5433C29.5681 17.8448 28.7879 18 28 18C27.2121 18 26.4319 17.8448 25.7039 17.5433C24.9759 17.2418 24.3145 16.7998 23.7574 16.2426C23.2002 15.6855 22.7583 15.0241 22.4567 14.2961C22.1552 13.5681 22 12.7879 22 12C22 10.4087 22.6321 8.88258 23.7574 7.75736C24.8826 6.63214 26.4087 6 28 6C29.5913 6 31.1174 6.63214 32.2426 7.75736C33.3679 8.88258 34 10.4087 34 12ZM27.8665 34C26.8067 34 26 33.0598 26 32C26.0046 28.8577 24.9475 25.806 23 23.34C24.5202 22.4623 26.2446 22.0003 27.9999 22.0003C29.7553 22.0002 31.4797 22.4623 32.9999 23.3399C34.5201 24.2176 35.7825 25.4799 36.6602 27.0001C37.5379 28.5202 38 30.2447 38 32C38 33.1046 37.1046 34 36 34H27.8665ZM12 22C14.6522 22 17.1957 23.0536 19.0711 24.9289C20.9464 26.8043 22 29.3478 22 32C22 33.1046 21.1046 34 20 34H4C2.89543 34 2 33.1046 2 32C2 29.3478 3.05357 26.8043 4.92893 24.9289C6.8043 23.0536 9.34784 22 12 22Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ coldContacts }}</h3>
                        <p>Cold Contacts</p>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M4.332 8.85512C10.1223 8.78312 15.6896 6.61204 20 2.74512C24.3101 6.61276 29.8775 8.78457 35.668 8.85712C35.888 10.1571 36 11.4971 36 12.8591C36 23.3091 29.32 32.1991 20 35.4931C10.68 32.1971 4 23.3071 4 12.8571C4 11.4931 4.114 10.1571 4.332 8.85512ZM27.414 16.2711C27.7783 15.8939 27.9799 15.3887 27.9753 14.8643C27.9708 14.3399 27.7605 13.8383 27.3896 13.4675C27.0188 13.0967 26.5172 12.8863 25.9928 12.8818C25.4684 12.8772 24.9632 13.0788 24.586 13.4431L18 20.0291L15.414 17.4431C15.0368 17.0788 14.5316 16.8772 14.0072 16.8818C13.4828 16.8863 12.9812 17.0967 12.6104 17.4675C12.2395 17.8383 12.0292 18.3399 12.0247 18.8643C12.0201 19.3887 12.2217 19.8939 12.586 20.2711L16.586 24.2711C16.9611 24.6461 17.4697 24.8567 18 24.8567C18.5303 24.8567 19.0389 24.6461 19.414 24.2711L27.414 16.2711Z"
                            fill="#A5A5A5" />
                        </svg>
                        <h3>{{ noResponse }}</h3>
                        <p>No Response</p>
                      </a>
                    </li>


                  </ul>
                </div>
              </div>
              <!-- activitybox -->
            </div>

            <div class="col-12">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="box-title">
                  <h3>Leads vs Serviced</h3>
                </div>
                <div class="chat-box">
                  <div id="Leads"></div>
<apexchart 
type="area" 
height="280" 
:options="leadsOptions" 
:series="leadsSeries"
></apexchart>
                </div>

              </div>
              <!-- activitybox -->
            </div>


            <div class="col-md-6">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="box-title">
                  <h3>Activity</h3>
                </div>
                <div class="chat-box">
                  <div id="Activits"></div>
<apexchart 
type="bar" 
height="280" 
:options="activityOptions" 
:series="activitySeries"
></apexchart>
                </div>

              </div>
              <!-- activitybox -->
            </div>


            <div class="col-md-6">
              <!-- activitybox -->
              <div class="activitybox">
                <div class="box-title">
                  <h3>Source Type</h3>
                </div>
                <div class="chat-box">
                  <div id="Sources"></div>
<apexchart 
type="bar" 
height="280" 
:options="sourcesOptions" 
:series="sourcesSeries"
></apexchart>
                </div>

              </div>
              <!-- activitybox -->
            </div>


          </div>
        </div>
        <!-- left-side -->


        <!-- right-side -->
        <div class="col-md-5 col-lg-4">
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Serviced</h3>
            </div>
            <div class="chat-box">
              <div id="Serviced"></div>
<apexchart 
type="donut" 
height="220" 
:options="donutOptions" 
:series="donutSeries"
></apexchart>
            </div>

          </div>
          <!-- activitybox -->


          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Message Funnel</h3>
            </div>
            <div class="sale-funnel">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="funnel-img"><img class="img-fluid" src="@/assets/img/Funnel.svg" alt="image title"></div>
                </div>
                <div class="col-md-6">
                  <div class="funnel-list">
                    <ul>
                      <li><a href="#">Status <h5>Leads</h5></a></li>
                      <li><a href="#"><span class="funnel-1"></span> Messages Sent <h5>{{ messagesSent }}</h5></a></li>
                      <li><a href="#"><span class="funnel-2"></span> Replies Received <h5>{{ repliesReceived }}</h5></a></li>
                      <li><a href="#"><span class="funnel-3"></span> Appointment Set <h5>{{ appointmentsSet }}</h5></a></li>
                      <li><a href="#"><span class="funnel-4"></span> Apps Shown <h5>{{ appsShown }}</h5></a></li>
                      <li><a href="#"><span class="funnel-5"></span> Opted Out <h5>{{ optedOut }}</h5></a></li>
                    </ul>
                  </div>
                </div>
                <div class="sale-table">
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>100% </th>
                          <th>75% </th>
                          <th>43% </th>
                          <th>10% </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Contacted </td>
                          <td>Appointment </td>
                          <td>Apps Shown </td>
                          <td>Delivered </td>
                        </tr>


                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- activitybox -->



          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Appointments</h3>
            </div>
            <div class="chat-box">
              <div id="Appointments"></div>
<apexchart 
type="bar" 
height="250" 
:options="appointmentOptions" 
:series="appointmentSeries"
></apexchart>
            </div>

          </div>
          <!-- activitybox -->


        </div>
      </div>
      <!-- right-side -->
    </div>
    <!-- activity-area -->



    <!-- activity-area -->
    <div class="activity-area">
      <div class="row">
        <div class="col-md-5 col-lg-4">
          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Appointments Type</h3>
            </div>

            <div class="appoin-type">
              <h2>375</h2>
              <p>Total Appointment</p>
              <div class="form-row">
                <div class="col-6">
                  <div class="media vitual">
                    <img src="@/assets/img/Virtual.png" class="mr-3 img-fluid" alt="image title">
                    <div class="media-body">
                      <h5 class="mt-0">275</h5>
                      <p>Virtual</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="media inperson">
                    <img src="@/assets/img/Person.png" class="mr-3 img-fluid" alt="image title">
                    <div class="media-body">
                      <h5 class="mt-0">142</h5>
                      <p>In Person</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- activitybox -->
        </div>
        <div class="col-md-7 col-lg-8">

          <!-- activitybox -->
          <div class="activitybox">
            <div class="box-title">
              <h3>Average Response Time</h3>
            </div>

            <div class="average-time">
              <div class="average">
                <h3>15:20</h3>
                <p>Minute</p>
              </div>
            </div>

          </div>
          <!-- activitybox -->
        </div>
      </div>
    </div>
    <!-- activity-area -->

</template>
<script>
import $ from "jquery";
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  setup() {
    const Router = useRouter();
    if(localStorage.getItem("user_id") != 177){
      Router.push("/inbox/all");
    }
    
    // Open Modal
    const openModal = () => {
      $("#featureNotAvailable").modal("show");
    };

    // Close Modal
    const closeModal = () => {
      $("#featureNotAvailable").modal("hide");
    };
    // let barChartSeries = ref([]);
    let todayAppointments = ref(0);
    let newMessages = ref(0);
    let unreadMessages = ref(0);
    let pendingFollowUp = ref(0);
    let newContacts = ref(0);
    let activeContacts = ref(0);
    let coldContacts = ref(0);
    let appointmentScheduled = ref(0);
    let noResponse = ref(0);
    let messagesSent = ref(0);
    let repliesReceived = ref(0);
    let appointmentsSet = ref(0);
    let appsShown = ref(0);
    let optedOut = ref(0);

    let activeAppointments = ref(0);
    let inboundLeads = ref(0);
    let totalConversation = ref(0);
    let averageResponseTime = ref('0m');

/* CHARTS */
// ===========================================
    // 1. LEADS CHART CONFIG
    // ===========================================
    const leadsSeries = ref([
      { name: 'Leads', data: [51, 40, 18, 51, 41, 109, 100] },
      { name: 'Serviced', data: [35, 32, 42, 24, 34, 52, 43] }
    ]);
    
    const leadsOptions = ref({
      colors: ['#F7AE33', '#5B93FF'],
      chart: { type: 'area', toolbar: { show: false } }, // Toolbar false looks cleaner
      dataLabels: { enabled: false },
      stroke: { width: 2, curve: 'smooth' },
      xaxis: {
        // Safe fix: Added categories to prevent date parsing crash
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      },
      tooltip: {
         // simplified tooltip
      },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 2. ACTIVITIES CHART CONFIG
    // ===========================================
    const activitySeries = ref([
      { name: 'Out', data: [44, 55, 57] },
      { name: 'In', data: [76, 85, 101] }
    ]);

    const activityOptions = ref({
      colors: ['#5B93FF', '#83AAF5'],
      chart: { type: 'bar', toolbar: { show: false } },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 4, // 'endingShape' is deprecated, use borderRadius
        },
      },
      dataLabels: { enabled: false },
      stroke: { show: true, width: 2, colors: ['transparent'] },
      xaxis: {
        categories: ['Call', 'Email', 'Text'],
      },
      fill: { opacity: 1 },
      legend: { position: 'top', horizontalAlign: 'right', offsetX: -10 }
    });

    // ===========================================
    // 3. SOURCES CHART CONFIG
    // ===========================================
    const sourcesSeries = ref([
      { data: [21, 22, 10] }
    ]);

    const sourcesOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#5B93FF', '#14B2D4', '#F7AE33'],
      plotOptions: {
        bar: {
          columnWidth: '20%',
          distributed: true,
          borderRadius: 6,
        }
      },
      dataLabels: { enabled: false },
      legend: { show: false },
      xaxis: {
        categories: ['Walk In', 'Phone', 'Internet']
      }
    });

    // ===========================================
    // 4. DONUT CHART CONFIG
    // ===========================================
    // Note: Donut series is a simple array, not an object array
    const donutSeries = ref([44, 55, 34]);

    const donutOptions = ref({
      chart: { type: 'donut' },
      colors: ['#5B93FF', '#14B2D4', '#FF8F6B'],
      dataLabels: { enabled: false },
      labels: ['New', ' Used', 'Purchase'],
      legend: { show: true, position: 'bottom', horizontalAlign: 'center' }
    });

    // ===========================================
    // 5. APPOINTMENTS CHART CONFIG
    // ===========================================
    const appointmentSeries = ref([
      { data: [32, 52, 58, 64, 12] }
    ]);

    const appointmentOptions = ref({
      chart: { type: 'bar', toolbar: { show: false } },
      colors: ['#14B2D4', '#5B93FF', '#19BE93', '#F7AE33', '#EA5757'],
      plotOptions: {
        bar: {
          barHeight: '20%',
          horizontal: true,
          distributed: true,
          borderRadius: 4,
          dataLabels: { position: 'top' }
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 0,
        offsetY: -20, // Adjusted to sit on top of thin bars
        style: { fontSize: '12px', colors: ['#000'] }
      },
      xaxis: {
        categories: ['Created', 'Scheduled', 'Confirmed', 'Show', 'No Show '],
      },
      legend: { show: false }
    });
/* CHARTS */
    const getDashboardData = async () => {
      const getFormData = new FormData();
      getFormData.append('dealer_id', localStorage.getItem('dealer_id'));
      getFormData.append('location_id', localStorage.getItem('location_id'));
      await axios
        .post(
          axios.defaults.baseUrl + "dashboard",
          getFormData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem('auth_token'),
            },
          }
        )
        .then((response) => {
          todayAppointments.value = response.data.data.todays_appointments;
          newMessages.value = response.data.data.new_messages;
          unreadMessages.value = response.data.data.unread_messages;
          pendingFollowUp.value = response.data.data.pending_follow_up;
          newContacts.value = response.data.data.new_contacts;
          activeContacts.value = response.data.data.active_contacts;
          coldContacts.value = response.data.data.cold_contacts;
          appointmentScheduled.value = response.data.data.appointment_scheduled;
          noResponse.value = response.data.data.no_response;
          messagesSent.value = response.data.data.messages_sent;
          repliesReceived.value = response.data.data.replies_received;
          appointmentsSet.value = response.data.data.appointments_set;
          appsShown.value = response.data.data.apps_shown;
          optedOut.value = response.data.data.opted_out;

          activeAppointments.value = response.data.data.active_appointments;
          inboundLeads.value = response.data.data.inbound_leads;
          totalConversation.value = response.data.data.total_conversations;
          averageResponseTime.value = response.data.data.average_response_time;
          // datatableInit();
        })
        .catch((error) => {
          window.showHideMainLoader(false);
          console.log(error);
          // showToast(error.response.data.status, error.response.data.message);
          return false;
        });
    }

    onMounted(() => {
      // console.log(localStorage.getItem('dealer_id'));
      // console.log(localStorage.getItem('location_id'));
      window.showHideMainLoader(false);
      getDashboardData();
      $(document).on('click','.menuwidth',function(e){
      console.log(e.target);
alert();
    });
    });

    return {
      openModal,
      closeModal,
      getDashboardData,
      todayAppointments,
      newMessages,
      unreadMessages,
      pendingFollowUp,
      newContacts,
      activeContacts,
      coldContacts,
      appointmentScheduled,
      noResponse,
      messagesSent,
      repliesReceived,
      appointmentsSet,
      appsShown,
      optedOut,
      activeAppointments,
      inboundLeads,
      totalConversation,
      averageResponseTime,

      // Return Leads
      leadsSeries,
      leadsOptions,
      // Return Activities
      activitySeries,
      activityOptions,
      // Return Sources
      sourcesSeries,
      sourcesOptions,
      // Return Donut
      donutSeries,
      donutOptions,
      // Return Appointments
      appointmentSeries,
      appointmentOptions
    };
  },
};
</script>
<style>
#printLead {
  display: none;
}

@media print {
  #printLead {
    display: block;
  }

  .main-area {
    display: none;
  }

  #leadDetailsContainer {
    display: block;
  }

  .mytable .table td:first-child {
    font-weight: 500;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  .mytable .table td,
  .mytable .table th {
    padding: 8px 0;
    vertical-align: middle;
    border-top: 1px solid transparent;
    border-bottom: 1px solid #e6e7e8;
    font-size: 14px;
    line-height: 1.5;
    color: #63729a;
  }

  span.dot {
    display: inline-block;
    height: 4px;
    width: 4px;
    background: #63729a;
    border-radius: 50%;
    margin-bottom: 1px;
    margin-right: 5px;
  }
}
</style>